
import { Alert, AlertTitle, Snackbar } from '@mui/material';
import { useState } from 'react';

//success pop up
export const Successalert = ({ message, onClose }) => {


    return (
        <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open onClose={() => onClose()} autoHideDuration={3000}>
            <Alert severity="success">{message}</Alert>
        </Snackbar>
    )
}

//Error Pop up
export const Erroralert = ({ message, onClose }) => {

    return (
        <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open onClose={() => onClose()} autoHideDuration={3000}>
            <Alert severity="error">{message}</Alert>
        </Snackbar>
    )
}

//Success Non pop up
export const Successnonpop = ({ message }) => {

    return (
        <Alert severity="success">
            <AlertTitle>Success</AlertTitle>
            {message}
        </Alert>
    )
}


//Error Non pop up
export const Errornonpop = ({ message }) => {

    return (
        <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {message} — <strong>check it out!</strong>
        </Alert>
    )
}